import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import { Row } from "react-bootstrap";

const IncomingCashsCustomerPaymentDetail = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext();
  return (
    <Row>
    </Row>
  );
};

export default IncomingCashsCustomerPaymentDetail;
